<template>
    <div class="learn-course__back">
        <button @click.prevent="actionHandler">
            <v-icon src="arrow-back" />
            <span>{{ title }}</span>
        </button>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Назад"
        },
        location: {
            type: Object,
            default: () => null
        }
    },
    methods: {
        actionHandler(event) {
            if (this.location) {
                this.$router.replace(this.location);
                return;
            }
            this.$emit("click", event);
        }
    }
};
</script>

<style scoped lang="scss">
.learn-course__back {
    padding: 0 32px;
    height: 72px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: -10px 6px 10px rgba(0, 0, 0, 0.1);
    @media (max-width: 769px) {
        box-shadow: none;
        height: auto;
    }
}
</style>
